/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import {
  isAdmin,
  isAdminAndManager,
  isLogin,
  Account,
  Logout,
  superAdmin,
} from './constants'
export default {
  [isAdmin]: (state, v) => {
    state[isAdmin] = v
  },
  [superAdmin]: (state, v) => {
    state[superAdmin] = v
  },
  [isAdminAndManager]: (state, v) => {
    state[isAdminAndManager] = v
  },
  [isLogin]: (state, v) => {
    state[isLogin] = v
  },
  [Account]: (state, v) => {
    state[Account] = v
  },
  [Logout]: (state, v) => {
    state[isLogin] = v
  },
}
